/**
 * ============================================================
 * Toki Pona
 * ============================================================
 *
 * Translators:
 *
 * jan Inkepa <analytic@gmail.com>
 */



export default {
	'AdvanceHelp': 'sina ken musi e musi ni kepeken ilo luka anu nena palisa pi ilo sitelen.',
	'AllowPlayback': 'sina wile kute e musi ni la o luka e mi.',
	'Audio': 'kalama',
	'AutoPlay': 'luka ala',
	'AutoPlayButton': 'o open e pali musi kepeken luka ala.',
	'AutoPlaySpeed': 'tenpo tawa pi luka ala',

	'Back': 'tenpo pini',
	'BackButton': 'o tawa tenpo pini.',

	'Cancel': 'ala',
	'Close': 'pini',
	'Confirm': 'sina wile ala wile pini e musi?',
	'Credits': 'pona tawa',

	'Delete': 'weka',
	'DialogLogButton': 'mi wile lukin e lipu pi toki jan.',

	'FullScreen': 'ma ale pi ilo lukin',

	'Gallery': 'ma sitelen',

	'Help': 'kama sona',
	'Hide': 'weka',
	'HideButton': 'o weka e palisa nena.',

	'iOSAudioWarning': 'sina ken ala ante e kalama lon ilo iOS',

	'KeyboardShortcuts': 'pali pi ilo sitelen',

	'Language': 'toki',
	'Load': 'awen musi',
	'LoadAutoSaveSlots': 'musi li awen e musi',
	'LoadButton': 'lipu awen pi tenpo pini.',
	'Loading': 'musi li kama...',
	'LoadingMessage': 'pali e awen',
	'LoadSlots': 'lipu awen',
	'LocalStorageWarning': 'mi ken ala kepeken e ken Local Storage lon ilo ni',
	'Log': 'lipu toki',

	'Music': 'kalama musi',

	'NewContent': 'musi ni li kama sin! sina wile musi e musi sin, la o kama sin tawa lipu ni.',
	'NoSavedGames': 'awen musi pi tenpo pina li lon ala.',
	'NoAutoSavedGames': 'awen musi pi tenpo pina li lon ala.',
	'NoDialogsAvailable': 'tenpo pini la toki jan li lon ala. jan li toki, la sina ken lukin ni lon lipu ni.',

	'OK' : 'pona',
	'OrientationWarning': 'sina wile musi, la o sike e ilo sona sina.',
	'Overwrite': 'ante',

	'QuickButtons': 'nena pi pali wawa',
	'QuickMenu': 'palisa nena',
	'Quit': 'pini',
	'QuitButton': 'o pini e musi.',

	'Resolution': 'suli musi tawa ilo sitelen',

	'Save': 'o awen e musi',
	'SaveButton': 'o lukin e lipu pi awen musi.',
	'SaveInSlot': 'o awen e musi lon ma.',
	'SelectYourLanguage': 'Select your language',
	'Settings': 'ante',
	'SettingsButton': 'o ante e musi.',
	'Show': 'open',
	'Skip': 'tawa tenpo kama',
	'SkipButton': 'o tawa tenpo kama.',
	'SlotDeletion': 'sina wile ala wile weka e awen musi ni?',
	'SlotOverwrite': 'sina wile ala wile ante e awen musi ni?',
	'Sound': 'kalama ijo',
	'Start': 'musi sin',
	'Stop': 'pini',

	'TextSpeed': 'tenpo kama pi sitelen toki',

	'Video': 'kalama pi sitelen tawa',
	'Voice': 'kalama toki',

	'Windowed': 'ma lili pi ilo lukin',
};
